module.exports = __webpack_public_path__ + "img/hamster.54d96677.gif";